import { useCallback, useState } from 'react';
import { SettingsApi } from '@/features/settings/api';
import { queryClient } from '@/app/QueryClientProvider';
import { usePopups } from '@/hooks';

export const useUpdateVerificationSettings = () => {
  const { showErrorToast, showSuccessToast } = usePopups();

  const [isUpdating, setIsUpdating] = useState(false);

  const handleUpdate = useCallback(async ({ visibleTypeGroup, verificationQuestionSectionId }) => {
    try {
      setIsUpdating(true);
      const res = await SettingsApi.updateVerificationSettings({
        visibleTypeGroup,
        verificationQuestionSectionId
      });
      await queryClient.refetchQueries({
        queryKey: ['settingsApi.getInvestorVerificationSettings']
      });
      showSuccessToast('Saved');
      return res;
    } catch (e) {
      showErrorToast(e, true);
    } finally {
      setIsUpdating(false);
    }
  }, []);

  return {
    handleUpdate,
    isUpdating
  };
};
